export const AGL_FORWARDER_NAME = 'AGL Forwarding Ops';
export const DEVICES_FORWARDER_NAME = 'Devices Global Logistics';
export const RETAIL_FORWARDER_NAME = 'Amazon Direct Imports';

export const flatEntryFee = 85;
export const defaultDisbursementFeeRateWithSubscriptions = 0.03;
export const defaultDisbursementFeeRateAfterSubscriptions = 0.02;
